export default "//file.bilionpass.com/japandx-web/0.0.1/static/circle.68b452b0-e055b2.svg";